import React from 'react';
import { EGROWTHBOOK_FEATURES_FLAGS } from '../../utils/growthbook-constants';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { growthbook } from '../../utils/growthbook';

const DigitalCatalogWrapper = styled.div`
  position: relative;
  height: 0;
  width: 100%;
  padding-top: max(45%, 326px);
  @media (max-width: ${(props) => props.theme.breakpoint.large}) {
    padding-top: max(160%, 600px);
  }
  @media (min-width: ${(props) => props.theme.breakpoint.large}) and (max-width: 1450px){
    padding-top: max(70%, 400px);
  }
`;

const DigitalCatalog = (props) => {
  const { growthbookFeatureFlagValues } = props;
  const { [EGROWTHBOOK_FEATURES_FLAGS.DIGITAL_CATALOG_SRC]: digitalCatalogSrc } = growthbookFeatureFlagValues;

  return (
    <DigitalCatalogWrapper>
      <iframe
        title="Issuu Digital Catalog"
        allow="clipboard-write"
        sandbox="allow-top-navigation allow-top-navigation-by-user-activation allow-downloads allow-scripts allow-same-origin allow-popups allow-modals allow-popups-to-escape-sandbox allow-forms"
        allowFullScreen
        style={{
          position: 'absolute',
          border: 'none',
          width: '100%',
          height: '100%',
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        }}
        src={digitalCatalogSrc ?? ''}></iframe>
    </DigitalCatalogWrapper>
  );
};

export async function getServerSideProps() {
  const isDigitalCatalogPageActive =  growthbook.isOn(EGROWTHBOOK_FEATURES_FLAGS.DIGITAL_CATALOG_ACTIVE);
  if(!isDigitalCatalogPageActive) {
    return { notFound: true }
  }
  return { props: {} };
}

DigitalCatalog.defaultProps = {
  growthbookFeatureFlagValues: {}
};

DigitalCatalog.propTypes = {
  growthbookFeatureFlagValues: PropTypes.object
};
export default DigitalCatalog;
